// [custom] dropped the registry's `import * as React` — this file never
// references the namespace, and the repo typechecks with noUnusedLocals, so
// the registry line is a hard error here. Re-check on the next re-pull.
'use client';

import {
  LabelContext,
  Label as LabelPrimitive,
  type LabelProps,
} from 'react-aria-components';

import { cn } from '@/shared/lib/cn';

function Label({ className, htmlFor, slot, ...props }: LabelProps) {
  const label = (
    <LabelPrimitive
      data-slot="label"
      className={cn(
        'flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 peer-data-disabled:opacity-50',
        className,
      )}
      {...props}
      htmlFor={htmlFor}
      slot={slot}
    />
  );

  if (htmlFor && slot === undefined) {
    return <LabelContext.Provider value={null}>{label}</LabelContext.Provider>;
  }

  return label;
}

export { Label };
